module.exports = __webpack_public_path__ + "img/station-icon_4.e8754b0c.png";